export default __webpack_public_path__ + "static/media/seangel6.b8271727.jpg";